import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class PricingV2 extends Component {

  constructor(props) {
    super(props);

    this.state = {
      packages: [],
      loading: true
    };
  }

  componentDidMount() {
    fetch("https://dashboard.converzex.com/api/public/packages")
        .then(res => res.json())
        .then(data => {


          this.setState({
            packages: data.data.packages,
            loading: false
          });

          console.log("API DATA:", data);
        })


        .catch(err => console.log(err));
  }

  render() {

    let publicUrl = process.env.PUBLIC_URL+'/'
    let imagealt = 'image'

    return  <section className="pricing-one pricing-one__home-three">
      <div className="container">
        <div className="block-title-two text-center">
          <h3>We Offer Awesome <br /> Pricing Plan</h3>
        </div>{/* /.block-title-two */}
        <div className="row">
          {this.state.packages.map((pkg) => (
              <div className="col-lg-4" key={pkg.id}>
                <div className="pricing-one__single">
                  <div className="pricing-one__inner">
                    <img src={publicUrl+"assets/images/shapes/pricing-i-1-1.png"} alt={ imagealt } />
                    <div className="pricing-one__top">
                      <h3>{pkg.name}</h3>
                      <br/>
                      <p><span>$</span>{pkg.price}</p>
                    </div>{/* /.pricing-one__top */}
                    {pkg.details && pkg.details.package_features && (
                        <ul className="pricing-one__list list-unstyled">
                          {pkg.details.package_features.map((feature, index) => (
                              <li key={index}>
                                <i className="far fa-check" /> {feature}
                              </li>
                          ))}
                        </ul>
                    )}
                    <a href="#" className="thm-btn pricing-one__btn">Choose Plan <i className="fa fa-angle-double-right" /></a>{/* /.thm-btn pricing-one__btn */}
                  </div>{/* /.pricing-one__inner */}
                </div>{/* /.pricing-one__single */}
              </div>
            ))}
        </div>{/* /.row */}
      </div>{/* /.container */}
    </section>

  }
}

export default PricingV2